import {useNavigate} from "react-router-dom";
import {KTSVG} from '@metronic/helpers'
import {observer} from "mobx-react";
import {useIntl} from "react-intl";
import React from "react";


const UsersListToolbar = observer(() => {

    const navigate = useNavigate()
    const openAddUserModal = () => {
        navigate('/companies/add')
    }
    const intl = useIntl()




    return (
        <div className='mb-9 d-flex justify-content-between'>
            <div className='d-flex justify-content-start' data-kt-user-table-toolbar='base'>
                {/*<UsersListFilter />*/}

                <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
                    <KTSVG path='/media/icons/duotune/general/gen041.svg' className='svg-icon-2' />
                    {intl.formatMessage({id:'createCompany'})}
                </button>
            </div>
            {/*<UsersListSearchComponent />*/}
        </div>
    )
})

export {UsersListToolbar}
